<template>
  <div itemscope itemtype="http://schema.org/Product">
   <v-container>
     <v-layout row wrap>
       <v-flex xs12>
         <v-card flat>
           <div itemprop="image">
           <v-card-media
             class="edomargintop"
             height="450px"
             alt="crossfind"
             :src="require('../assets/crossfind.jpg')">
             <v-container fill-height>
               <v-layout fill-height>
                 <v-flex xs12 align-end flexbox>
                   <div class="edoschriftzentriert">
                   <div class="edologobild"> <img src="../assets/xFIND-Logo_2018.svg"/>
                   </div>
                   <span class="edoheadlinemit"><span style="color:#AFB1B4">GUT</span> <span style="color:#0E3A53"> FINDEN </span> </span>
                   </div>
                 </v-flex>
               </v-layout>
             </v-container>
           </v-card-media>
           </div>
         </v-card>
       </v-flex>
     </v-layout>

     <div>
       <v-breadcrumbs divider=">" class="edobread">
         <v-breadcrumbs-item
           v-for="item in items"
           :key="item.text"
           :disabled="item.disabled"
         >
           <a :href='item.route'>{{ item.text }}</a>
         </v-breadcrumbs-item>
       </v-breadcrumbs>
     </div>

       <v-container fluid grid-list-md>
         <v-layout row justify-space-around>
           <v-flex d-flex xs12 sm12 md12>
             <v-card class="edomargintop" flat>
               <v-card-title primary class="title edoheadlinetext">
                 <span itemprop="name">
                 <span style="color:#AFB1B4">CROSS</span><span style="color:#0E3A53">FIND</span>
                 </span>
               </v-card-title>
               <v-card-text class="edoLineText">
                 <span itemprop="description">
                 Eingescannte Rechnungen, Schriftstücke oder Artikel wieder finden, kann viel Zeit in Anspruch nehmen. Sucht man nur ein Dokument kann das schon eine Herausforderung sein, sucht man allerdings aus tausenden Schriftstücken alle die, die eine Gemeinsamkeit aufweisen, wie einen Namen, so ist dies eine Aufgabe die fast unmöglich scheint. crossFIND bietet Ihnen eine einfache Lösung.
                 </span>
               </v-card-text>
             </v-card>
           </v-flex>
         </v-layout>
       </v-container>
     <v-container fluid grid-list-md>
       <v-layout row wrap justify-space-around>
         <v-flex xs12 sm4 md4>
           <v-card flat>
             <v-card-media
               class="edomargintop"
               height="250px"
               :src="require('../assets/Hinzufuegen.jpg')">
             </v-card-media>
           </v-card>
         </v-flex>
         <v-flex d-flex xs12 sm4 md4>
           <v-card class="edomargintop" flat>
             <v-card-title primary class="title edoheadlinetextcrossfind">HINZUFÜGEN</v-card-title>
             <v-card-text class="edoLineText">
               Fügen Sie Ihre Daten hinzu – per Scan oder Drag&Drop direkt aus dem Web. So finden Ihre Dokumente ihren Platz am richtigen Ort.             </v-card-text>
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>

     <v-container fluid grid-list-md>
       <v-layout row  wrap justify-space-around>
         <v-flex d-flex xs12 sm4 md4>
           <v-card class="edoborder" flat>
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>

     <v-container fluid grid-list-md>
       <v-layout row wrap justify-space-around>
         <v-flex d-flex xs12 sm4 md4>
           <v-card class="edomargintop" flat>
             <v-card-title primary class="title edoheadlinetextcrossfind">CROSSIFIZIEREN</v-card-title>
             <v-card-text class="edoLineText">
               crossFIND ermittelt automatisch relevante Informationen, wie z.B.  Absender, Datum, Rechnungsbetrag u.v.m. Durch diese Indexierung können Sie Ihre Daten leichter und schneller finden.
             </v-card-text>
           </v-card>
         </v-flex>
         <v-flex xs12 sm4 md4>
           <v-card flat>
             <v-card-media
               class="edomargintop"
               height="250px"
               :src="require('../assets/Crossifizieren.jpg')">
             </v-card-media>
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>

     <v-container fluid grid-list-md>
       <v-layout row  wrap justify-space-around>
         <v-flex d-flex xs12 sm4 md4>
           <v-card class="edoborder" flat>
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>

     <v-container fluid grid-list-md>
       <v-layout row  wrap justify-space-around>
         <v-flex xs12 sm4 md4>
           <v-card flat>
             <v-card-media
               class="edomargintop"
               height="250px"
               :src="require('../assets/Finden.jpg')">
             </v-card-media>
           </v-card>
         </v-flex>
         <v-flex d-flex xs12 sm4 md4>
           <v-card class="edomargintop" flat>
             <v-card-title primary class="title edoheadlinetextcrossfind">GUT FINDEN</v-card-title>
             <v-card-text class="edoLineText">
               Finden Sie Ihre Daten schneller – durch unsere komfortable Volltextsuche. Einfach Suchbegriff, Kategorie oder Datum eingeben und Ihre Daten sind in Sekundenschnelle gefunden.             </v-card-text>
           </v-card>
         </v-flex>
       </v-layout>
     </v-container>

     <v-layout row  wrap justify-space-around>
       <div class="text-xs-center edomargintop">
         <v-btn outline color="grey darken-3" @click="routeTo('https://ms.restservice.cloud/#/register')">JETZT KOSTENLOS REGISTRIEREN</v-btn>
       </div>
     </v-layout>
     <v-layout row wrap>
       <v-container>
         <v-card class="edoabstandfooter" flat>
         </v-card>
       </v-container>
     </v-layout>
     </v-container>
  </div>
</template>

<script>
  export default {
    name: 'Crossfind',
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: 'Crossfind – das Dokumenten Such System',
      meta: [
        {
          name: 'description',
          content: 'Die findige Lösung für Ihre Dokumente – kein lästiges suchen mehr von Schriftstücken.'
        }]
    },
    data: () => ({
      items: [
        {
          text: 'Home',
          route: '/home',
          disabled: false
        },
        {
          text: 'Produkte',
          route: '/produkte',
          disabled: false
        },
        {
          text: 'crossFIND',
          route: '',
          disabled: true
        }
      ]
    }),
    methods: {
      routeTo (url) {
        window.location = url
      }
    },
    mounted () {
      console.log('Crossfind')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Crossfind.vue